module.exports = __webpack_public_path__ + "static/media/makefirst.3b094ade.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/ibm/makefirst.png
// module id = 108
// module chunks = 0